import { BaseService } from 'core/services';
import { AlertsRouteService } from 'common/data';

class AlertsService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new AlertsRouteService());
	}

	getRunningJobs = () => {
		const url = this.routeService.getRunningJobs();
		return this.apiClient.get(url);
	};

    getAllScheudledJobLogs = () => {
        const url = this.routeService.getAllScheduledJobLogs();
		return this.apiClient.get(url);
    }

	getScheduledJobEstimates = () => {
		const url = this.routeService.getScheduledJobEstimates();
		return this.apiClient.get(url);
	}
}

export default AlertsService;
